import BaseApi from '~/api/base';
class DocumentComparisons extends BaseApi {
    constructor() {
        super('/document-comparison');
    }
    updateStatus(id, payload) {
        return super.route('/document-comparison/status').update(id, payload);
    }
}
const DocumentComparisonsApi = new DocumentComparisons();
export default DocumentComparisonsApi;
